import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-slate-900 text-slate-400 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <Link to="/" className="inline-block mb-4">
                            <div className="bg-blue-600 rounded-lg p-1 shadow-md inline-block">
                                <div className="border-2 border-white rounded px-3 py-0.5">
                                    <span className="font-black text-lg text-white tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                                        PHONEB2B
                                    </span>
                                </div>
                            </div>
                        </Link>
                        <p className="text-sm">
                            Plateforme B2B de vente de smartphones testés. Réservé aux professionnels.
                        </p>
                    </div>
                    
                    <div>
                        <h4 className="font-semibold text-white mb-4">Produits</h4>
                        <ul className="space-y-2 text-sm">
                            <li>Smartphones fonctionnels</li>
                            <li>Appareils à réparer</li>
                            <li>Stock temps réel</li>
                        </ul>
                    </div>
                    
                    <div>
                        <h4 className="font-semibold text-white mb-4">Services</h4>
                        <ul className="space-y-2 text-sm">
                            <li>Livraison 24h</li>
                            <li>Facturation B2B</li>
                            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
                        </ul>
                    </div>
                    
                    <div>
                        <h4 className="font-semibold text-white mb-4">Légal</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/cgv" className="hover:text-white">CGV</Link></li>
                            <li><Link to="/privacy" className="hover:text-white">Confidentialité & Cookies</Link></li>
                            <li><Link to="/mentions" className="hover:text-white">Mentions légales</Link></li>
                            <li><Link to="/grades" className="hover:text-white">Guide des grades</Link></li>
                        </ul>
                    </div>
                </div>
                
                <div className="border-t border-slate-800 pt-8 text-center text-sm">
                    <p>© {new Date().getFullYear()} PHONEB2B. Tous droits réservés. Plateforme réservée aux professionnels.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
